export default __webpack_public_path__ + "static/media/offer-5.0ba976f4.jpg";